import '../styles/mandant.css';
import '../styles/mandant-shell.css';
import { useCallback, useMemo, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { t } from '../i18n';
import { useConfig } from '../lib/config';
import type { Me } from '../types';
import { AddCompany } from './account/AddCompany';
import { LoginCodePage } from './account/LoginCodePage';
import { RegistrationStatus } from './account/RegistrationStatus';
import { useSessionLive } from './account/useSessionLive';
import { BelegeRoutes } from './belege/BelegeRoutes';
import { OldBriefeRedirect } from './briefe/BriefeRoutes';
import { ChatRoutes } from './chat/ChatRoutes';
import { ClientLayout } from './ClientLayout';
import { ClientAppContext, type ClientAppValue } from './context';
import { DokumenteRoutes } from './dokumente/DokumenteRoutes';
import { Home } from './Home';
import { LohnRoutes } from './lohn/LohnRoutes';
import { JaRoutes } from './jahresabschluss/JaRoutes';
import { PageProvider, type PageInfo } from './page';
import { RechnungenRoutes } from './rechnungen/RechnungenRoutes';

// Mandanten-App. Ohne freigegebene Firma sieht der Mandant nur den Status seiner Registrierung.
export function ClientApp({ me }: { me: Me }) {
  const config = useConfig();
  const active = useMemo(() => me.clients.filter((c) => c.status === 'active'), [me.clients]);
  const [page, setPageState] = useState<PageInfo>({ title: 'Elbcons' });
  const setPage = useCallback((p: PageInfo) => setPageState(p), []);
  useSessionLive(active.length > 0);

  const value = useMemo<ClientAppValue>(
    () => ({
      me,
      clients: active,
      config,
      clientName: (id) => active.find((c) => c.id === id)?.name ?? t('Meine Firma'),
    }),
    [me, active, config],
  );

  if (active.length === 0) return <RegistrationStatus me={me} />;

  return (
    <ClientAppContext.Provider value={value}>
      <PageProvider set={setPage}>
        <ClientLayout page={page}>
          <Routes>
            <Route index element={<Home />} />
            <Route path="belege/*" element={<BelegeRoutes />} />
            <Route path="dokumente/*" element={<DokumenteRoutes />} />
            <Route path="briefe/*" element={<OldBriefeRedirect />} />
            <Route path="mitarbeiter/*" element={<LohnRoutes />} />
            <Route path="jahresabschluss/*" element={<JaRoutes />} />
            <Route path="nachrichten/*" element={<ChatRoutes />} />
            <Route path="rechnungen/*" element={<RechnungenRoutes />} />
            <Route path="firma-anmelden" element={<AddCompany />} />
            <Route path="login-code" element={<LoginCodePage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </ClientLayout>
      </PageProvider>
    </ClientAppContext.Provider>
  );
}
